import { Agent, Channel, MerchantStructure, User, UserType } from '@nemuru-eng/js-api-client';

import { ApplicationType } from '@/config/types';
import MerchantStructureEntity from '@/entities/MerchantStructureEntity';
import { UserEntity } from '@/entities/UserEntity';
import { MerchantInStructure } from '@/types/MerchantInStructure';

export default class UserInMerchantStructure extends UserEntity {
  public readonly merchant: MerchantInStructure;
  public readonly channel: Channel;
  public readonly agent: Agent;
  public readonly allowedProducts: ApplicationType[];

  constructor(user: User, merchantStructure: MerchantStructure) {
    super(user);
    const merchantStructureEntity = MerchantStructureEntity.create({
      merchantStructure,
      ...(this.isUserType(UserType.CHANNEL) && { channelId: this.user.userId }),
      ...(this.isUserType(UserType.AGENT) && { agentId: this.user.userId }),
    });
    this.merchant = merchantStructureEntity.getMerchant();
    this.channel = merchantStructureEntity.getChannelOrFirstChannel();
    this.agent = merchantStructureEntity.getAgentOrFirstAgent();
    this.allowedProducts = merchantStructureEntity.getAllowedProducts();
    this.allowedPaymentMethodTypes = merchantStructureEntity.getAllowedPaymentMethodsByUserType();
  }

  public get name(): string {
    // Returns the name of the user
    if (this.isUserType(UserType.MERCHANT)) {
      return this.merchant.businessName;
    }
    if (this.isUserType(UserType.CHANNEL)) {
      return this.channel.description;
    }
    if (this.isUserType(UserType.AGENT)) {
      return this.agent.name;
    }
    return this.user.username;
  }

  public get field(): string {
    // Returns the field of the user
    if (this.isUserType(UserType.MERCHANT)) {
      return 'merchant_id';
    }
    if (this.isUserType(UserType.CHANNEL)) {
      return 'channel_id';
    }
    if (this.isUserType(UserType.AGENT)) {
      return 'agent_id';
    }
    return 'user_id';
  }
}
